export default __webpack_public_path__ + "static/media/DNo.36-2.9077e507.jpg";